import React, { useState, forwardRef, Ref } from "react";

import LoginButton from "components/molecules/LoginButton";
import "../../../../css/createTikTokDestination.css";
import SwalAlertComp from "../../../SwalAlert";
import { useSelector } from "react-redux";
import {
    authorizeRCapi,
    getRCapiAuthUrl,
} from "helpers/Sources/rcapi/rcapisource";

import { RedditCapiOwnProps } from "./RedditCapi.types";

const RedditCapi = forwardRef(
    ({ onLogin, label }: RedditCapiOwnProps, ref: Ref<HTMLButtonElement>) => {
        const language = useSelector(
            (state: any) => state.languagesState.languages,
        );
        const [isLoading, setIsLoading] = useState(false);

        const handleSuccess = async (data: { code?: string }) => {
            setIsLoading(true);
            const response = await authorizeRCapi({ code: data.code ?? "" });
            if (response.status) {
                onLogin(response);
            } else {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.failed ?? "Failed",
                    message: response.message,
                    icon: "error",
                });
            }
            setIsLoading(false);
        };

        return (
            <div className="w-full">
                <div className="position-relative overflow-hidden z-1">
                    <LoginButton
                        code="reddit"
                        getAuthUrl={() =>
                            getRCapiAuthUrl().then((r) =>
                                r?.status && r?.data ? r.data : null,
                            )
                        }
                        paramNames={["code"]}
                        onSuccess={handleSuccess}
                        dataTransform={(params) => ({ code: params.code })}
                        logoSrc="/assets/images/typeImages/reddit-capi.png"
                        buttonText={label}
                        isLoadingExternal={isLoading}
                    />
                </div>
            </div>
        );
    },
);

export default RedditCapi;
